export default __webpack_public_path__ + "static/media/File_No_2.39224f73.pdf";